import React, { useEffect } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'sonner';
import { paths } from '../routes';

const ProtectedRoutes = () => {
	const { institutionId, accessToken, isAuthenticated } = useSelector((state) => state.auth);
	const userData = useSelector((state) => state.user);
	const location = useLocation();

	useEffect(() => {
		if (!institutionId || !accessToken || !userData.id) {
			toast.error('Please log in to access this page');
		}
	}, [institutionId, accessToken, userData.id]);

	if (!institutionId || !accessToken || !userData.id) {
		return (
			<Navigate
				to={paths.LOGIN}
				state={{ from: location }}
				replace
			/>
		);
	}

	return <Outlet />;
};

export default ProtectedRoutes;
